/* ============================================================================
   Covebourne — the shop
   ----------------------------------------------------------------------------
   Enhancement only. With this file blocked every page still works: filters and
   sort are an ordinary form, the product page posts to the cart, and the cart
   has an Update button. What this adds is doing those things without a reload.
   ========================================================================== */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function each(scope, selector, fn) {
    Array.prototype.forEach.call(scope.querySelectorAll(selector), fn);
  }

  function setCartCount(count) {
    each(document, '[data-cart-count]', function (el) { el.textContent = count; });
  }

  function json(response) {
    return response.json().then(function (body) { return { ok: response.ok, body: body }; });
  }

  /* ---- quantity steppers, product and cart -------------------------------- */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-qty-step]');
    if (!button) return;
    var input = button.parentNode.querySelector('input');
    var floor = parseInt(input.min || '0', 10);
    var next = Math.max(floor, (parseInt(input.value, 10) || 0) + parseInt(button.getAttribute('data-qty-step'), 10));
    if (String(next) === input.value) return;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---- product ------------------------------------------------------------- */
  function Product(el) {
    var form = el.querySelector('[data-buy]');
    if (!form || form.cbReady) return;
    form.cbReady = true;

    var source = el.querySelector('[data-variants]');
    var variants = source ? JSON.parse(source.textContent) : [];
    var idInput = form.querySelector('[data-variant-id]');
    var addButton = form.querySelector('[data-add]');
    var status = form.querySelector('[data-status]');
    var priceNow = el.querySelector('[data-price-now]');
    var priceWas = el.querySelector('[data-price-was]');
    var stage = el.querySelector('[data-main]');
    var thumbs = Array.prototype.slice.call(el.querySelectorAll('[data-media-id]'));
    var groups = Array.prototype.slice.call(form.querySelectorAll('[data-option-index]'));
    var rows = Array.prototype.slice.call(form.querySelectorAll('[data-variant-row]'));
    var labels = { add: addButton.getAttribute('data-label-add'), added: addButton.getAttribute('data-label-added'), soldout: addButton.getAttribute('data-label-soldout') };
    var addedTimer;

    if (!variants.length) return;

    // The hidden variant field ships switched off so it cannot fight the no-script
    // menu. Scripts are clearly running, so switch it on and keep it correct from here.
    if (idInput) idInput.disabled = false;

    function byId(id) {
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i];
      return null;
    }

    var current = byId(form.getAttribute('data-current')) || variants[0];

    function showMedia(thumb) {
      if (!thumb || !stage) return;
      stage.srcset = thumb.getAttribute('data-srcset');
      stage.src = thumb.getAttribute('data-src');
      stage.alt = thumb.getAttribute('data-alt');
      thumbs.forEach(function (other) {
        var on = other === thumb;
        other.classList.toggle('is-current', on);
        other.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { showMedia(thumb); });
    });

    function say(text, link, isError) {
      status.textContent = '';
      status.classList.toggle('is-error', !!isError);
      if (!text) return;
      status.appendChild(document.createTextNode(text));
      if (link) {
        var a = document.createElement('a');
        a.href = root + 'cart';
        a.textContent = link;
        status.appendChild(document.createTextNode(' '));
        status.appendChild(a);
      }
    }

    function setButton() {
      window.clearTimeout(addedTimer);
      addButton.disabled = !current || !current.available;
      addButton.textContent = current && current.available ? labels.add : labels.soldout;
    }

    // A value is struck through when it is sold out alongside the other choices as they
    // stand, and only switched off entirely when no in-stock variant carries it at all.
    function markGroups() {
      groups.forEach(function (group) {
        var index = parseInt(group.getAttribute('data-option-index'), 10);
        each(group, 'input[type="radio"]', function (input) {
          var here = false;
          var anywhere = false;
          variants.forEach(function (variant) {
            if (variant.options[index] !== input.value || !variant.available) return;
            anywhere = true;
            var matches = variant.options.every(function (value, i) { return i === index || value === current.options[i]; });
            if (matches) here = true;
          });
          input.disabled = !anywhere;
          input.parentNode.classList.toggle('is-soldout', !here);
          input.checked = current.options[index] === input.value;
        });
        var shown = group.querySelector('[data-option-current]');
        if (shown) shown.textContent = current.options[index];
      });
    }

    function apply(variant, quiet) {
      current = variant;
      if (idInput) idInput.value = variant.id;
      if (priceNow) priceNow.textContent = variant.price;
      if (priceWas) {
        priceWas.textContent = variant.was || '';
        priceWas.hidden = !variant.was;
      }
      setButton();
      markGroups();
      rows.forEach(function (input) { input.checked = String(input.value) === String(variant.id); });
      if (variant.media) {
        showMedia(thumbs.filter(function (thumb) { return thumb.getAttribute('data-media-id') === String(variant.media); })[0]);
      }
      if (!quiet) {
        say('');
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
    }

    groups.forEach(function (group) {
      var index = parseInt(group.getAttribute('data-option-index'), 10);
      group.addEventListener('change', function (event) {
        var value = event.target.value;
        var wanted = current.options.slice();
        wanted[index] = value;
        var exact = variants.filter(function (variant) {
          return variant.options.every(function (v, i) { return v === wanted[i]; });
        })[0];
        // No such pairing, or it is sold out: fall to the first in-stock variant with this value.
        var fallback = variants.filter(function (variant) { return variant.options[index] === value && variant.available; })[0];
        apply(exact && exact.available ? exact : (fallback || exact || current));
      });
    });

    rows.forEach(function (input) {
      input.addEventListener('change', function () {
        var variant = byId(input.value);
        if (variant) apply(variant);
      });
    });

    form.addEventListener('submit', function (event) {
      if (!window.fetch || !window.FormData) return;
      event.preventDefault();
      if (addButton.disabled) return;
      addButton.disabled = true;
      say('');

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(json)
        .then(function (result) {
          if (!result.ok) throw new Error(result.body.description || result.body.message || 'That could not be added to your cart.');
          return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          setCartCount(cart.item_count);
          addButton.disabled = false;
          addButton.textContent = labels.added;
          say('It is in your cart.', 'View cart');
          addedTimer = window.setTimeout(setButton, 2600);
        })
        .catch(function (error) {
          setButton();
          say(error.message, null, true);
        });
    });

    apply(current, true);
  }

  /* ---- cart ---------------------------------------------------------------- */
  function Cart(el) {
    if (el.cbReady) return;
    el.cbReady = true;
    var sectionId = el.getAttribute('data-section-id');

    function swap(html) {
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart]');
      if (fresh) el.innerHTML = fresh.innerHTML;
      el.classList.remove('is-busy');
    }

    function change(line, quantity) {
      el.classList.add('is-busy');
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: [sectionId], sections_url: window.location.pathname })
      })
        .then(json)
        .then(function (result) {
          if (result.ok && result.body.sections && result.body.sections[sectionId]) {
            swap(result.body.sections[sectionId]);
            setCartCount(result.body.item_count);
            return;
          }
          // Shopify refused (usually more than is in stock). Redraw the true cart and say why.
          var reason = result.body.description || result.body.message || '';
          return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId))
            .then(function (r) { return r.text(); })
            .then(function (html) {
              swap(html);
              var slot = el.querySelector('[data-cart-error]');
              if (slot) slot.textContent = reason;
            });
        })
        .catch(function () { window.location.reload(); });
    }

    function lineOf(node) {
      return parseInt(node.closest('[data-line]').getAttribute('data-line'), 10);
    }

    el.addEventListener('change', function (event) {
      if (!event.target.matches('[data-line-qty]')) return;
      change(lineOf(event.target), Math.max(0, parseInt(event.target.value, 10) || 0));
    });

    el.addEventListener('click', function (event) {
      var remove = event.target.closest('[data-line-remove]');
      if (!remove) return;
      event.preventDefault();
      change(lineOf(remove), 0);
    });
  }

  /* ---- filters and sort ---------------------------------------------------- */
  function Facets() {
    var form = document.getElementById('CbFacets');
    if (!form || form.cbReady) return;
    form.cbReady = true;

    function go() {
      var params = new URLSearchParams();
      new FormData(form).forEach(function (value, key) {
        if (value !== '') params.append(key, value);
      });
      var path = new URL(form.getAttribute('action'), window.location.origin).pathname;
      var query = params.toString();
      window.location.assign(path + (query ? '?' + query : ''));
    }

    // Ticks and sort apply at once. Price waits for Apply or Enter, so typing a
    // range does not reload the page between the two boxes.
    form.addEventListener('change', function (event) {
      if (event.target.closest('[data-price]')) return;
      go();
    });
    each(document, '[form="CbFacets"]', function (control) {
      control.addEventListener('change', go);
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      go();
    });

    var toggle = document.querySelector('[data-facets-toggle]');
    var rail = document.querySelector('[data-facets]');
    if (toggle && rail) {
      toggle.addEventListener('click', function () {
        var open = rail.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  /* ---- shop menu: Escape hands focus back so the panel closes -------------- */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var active = document.activeElement;
    if (active && active.closest && active.closest('.cb-mast__item--menu')) active.blur();
  });

  function boot() {
    each(document, '[data-product]', Product);
    each(document, '[data-cart]', Cart);
    Facets();
  }

  boot();
  // The theme editor swaps sections in and out; pick the new markup up when it does.
  document.addEventListener('shopify:section:load', boot);
})();
